import React from 'react'
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from '../ui/dialog'
import { Button } from '../ui/button'
import LegalDocViewer from './LegalDocViewer'

// Link/botón que abre un diálogo con el documento legal renderizado.
// - `doc`: objeto { titulo, version, contenido } de src/lib/services/legal.js
// - `label`: texto del enlace (por defecto, el título del documento)
// - `children`: trigger personalizado (asChild) si se quiere otro estilo
const LegalDocLink = ({ doc, label, className, children }) => {
  if (!doc) return null
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children || (
          <button
            type="button"
            className={className || 'text-primary underline text-sm hover:opacity-80 text-left'}
          >
            {label || doc.titulo}
          </button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{doc.titulo}</DialogTitle>
        </DialogHeader>
        <LegalDocViewer doc={doc} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cerrar</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default LegalDocLink
